import { createSlice } from "@reduxjs/toolkit";

const sportsSlice = createSlice({
  name: "sports",
  initialState: {
    sportKeys: [
      { id: "cricket", title: "Cricket", source: 'SportsRadar' },
      { id: "football", title: "Football", source: 'SportsApi' },
      { id: "kabaddi", title: "Kabaddi", source: 'BlaskApi' },
      { id: "tennis", title: "Tennis", source: 'LSports' },
      { id: "basketball", title: "Basketball", source: 'LSports' },
    ],
  },
  reducers: {},
});

export default sportsSlice.reducer;
